<template>
  <div class="CustomButton">
    <el-button
      v-if="resizeOnMobile && isMobile"
      class="CustomButton"
      :style="{
        background: background,
        color: textColor,
        border: border,
        padding: padding,
      }"
      :disabled="disabled || isLoading"
      @click.stop="handleClick"
    >
      <slot name="text" />
    </el-button>
    <el-button
      v-else
      class="CustomButton"
      :class="{ animate: isAnimateHover, defaultHover: isDefaultHover }"
      :disabled="disabled || isLoading"
      @click.stop="handleClick"
      :style="{
        background: background,
        color: textColor,
        border: border,
        padding: padding,
        'border-radius': borderRadius + 'px',
      }"
    >
      <i
        v-if="isLoading"
        class="fa fa-spinner fa-spin CustomButton__icon"
        aria-hidden="true"
      />
      <div v-else>
        <span class="text">
          <slot name="text"></slot>
        </span>

        <div class="icon" :style="{ 'font-size': iconSize + 'px' }">
          <slot name="icon" />
        </div>
      </div>
    </el-button>
  </div>
</template>

<script src="./component.js"></script>
<style src="./style.sass" lang="sass" scoped></style>
